import { ProfileServiceInterface } from "interfaces/profile-service"
import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"

export class BusinessProfileService
    extends BaseBusinessService
    implements ProfileServiceInterface
{
    useGetSelfProfile = () => {
        return this.get({ endpoint: '' })
    }

    useResetPassword = (email: string) => {
        return this.post({ endpoint: `/reset-password?email=${email}` })
    }

    useSelfContext = () => {
        return this.get({ endpoint: `/login` })
    }

    useGetSelfEntity = () => {
        return this.get({ endpoint: `/entity` })
    }

    usePostSendEmail = (email: string) => {
        return this.post({ endpoint: `/resend-email?email=${email}` })
    }
}
